import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Forwarder from '@SiteContainers/Forwarder'
import AssetsTable from '@SiteContainers/AssetsTable'
import Sidebar from '@SiteContainers/Sidebar'

import {
  fetchElements,
} from '@SiteModules/Element/actions'

import {
  getCurrentWorkspaceId,
} from '@SiteModules/Workspace/selectors'

import {
  getHasLoadedInitially,
} from '@SiteModules/Element/selectors'

import './Assets.scss'

const Assets: React.FC = () => {
  const dispatch = useDispatch()

  const currentWorkspaceId = useSelector(getCurrentWorkspaceId)
  const hasLoadedInitially = useSelector(getHasLoadedInitially)

  useEffect(() => {
    if (currentWorkspaceId >= 0 && !hasLoadedInitially) {
      dispatch(fetchElements({ workspaceId: currentWorkspaceId, page: 1 }))
    }
  } , [currentWorkspaceId, hasLoadedInitially])

  const renderAssets = () => {
    return (
      <div
        className="Assets"
        id="assets"
      >
        <Sidebar
          pageName="assets"
        />
        <AssetsTable />
      </div>
    )
  }

  return (
    <React.Fragment>
      <Forwarder />
      {renderAssets()}
    </React.Fragment>
  )
}

export default Assets
